var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEye, faTrash, faPlug, } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";
import { useDeleteConnectorMutation, useGetConnectorsQuery, useSaveConnectorMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { Input, Option, Select } from "@mui/joy";
export default function Connector() {
    var _this = this;
    var _a = useGetConnectorsQuery(null), backendConnectors = _a.data, isLoadConnector = _a.isLoading;
    var _b = useState([]), connectors = _b[0], setConnectors = _b[1];
    var _c = useState(null), selected = _c[0], setSelected = _c[1];
    var mainTypes = ["LLM", "SugarCRM", "Calendar", "Contact", "SocialNetwork"];
    var llmSubTypes = ["openai", "anthropic", "custom"];
    var deleteConnector = useDeleteConnectorMutation()[0];
    var saveConnector = useSaveConnectorMutation()[0];
    useEffect(function () {
        var _a;
        var connectorsFromBackend = (_a = backendConnectors === null || backendConnectors === void 0 ? void 0 : backendConnectors.data) === null || _a === void 0 ? void 0 : _a.connectors;
        if (connectorsFromBackend) {
            setConnectors(connectorsFromBackend);
        }
    }, [backendConnectors]);
    var addConnector = function () {
        var newConnector = {
            id: crypto.randomUUID(),
            name: "New Connector",
            type: "LLM",
            subType: "custom",
            description: "New connector",
            config: JSON.stringify({ apiKey: "", model: "" }, null, 2),
        };
        setConnectors(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newConnector], false); });
        setSelected(newConnector);
    };
    var updateSelected = function (key, value) {
        if (!selected)
            return;
        setSelected(function (prev) {
            var _a;
            if (!prev)
                return prev;
            var updated = __assign(__assign({}, prev), (_a = {}, _a[key] = value, _a));
            setConnectors(function (prevConnectors) {
                return prevConnectors.map(function (c) { return (c.id === prev.id ? updated : c); });
            });
            return updated;
        });
    };
    var handleDelete = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var existsInBackend, confirmed, result, err_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    existsInBackend = (_b = (_a = backendConnectors === null || backendConnectors === void 0 ? void 0 : backendConnectors.data) === null || _a === void 0 ? void 0 : _a.connectors) === null || _b === void 0 ? void 0 : _b.some(function (c) { return c.id === id; });
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    if (!existsInBackend) {
                        setConnectors(function (prev) { return prev.filter(function (c) { return c.id !== id; }); });
                        if ((selected === null || selected === void 0 ? void 0 : selected.id) === id)
                            setSelected(null);
                        toast.success("Connector removed!");
                        return [2 /*return*/];
                    }
                    confirmed = window.confirm("Are you sure you want to delete this connector?\nThis action cannot be undone.");
                    if (!confirmed)
                        return [2 /*return*/];
                    return [4 /*yield*/, deleteConnector({ id: id }).unwrap()];
                case 2:
                    result = _e.sent();
                    setConnectors((_d = (_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.connectors) !== null && _d !== void 0 ? _d : []);
                    if ((selected === null || selected === void 0 ? void 0 : selected.id) === id)
                        setSelected(null);
                    toast.success("Connector deleted successfully!");
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _e.sent();
                    console.error(err_1);
                    toast.error("Failed to delete connector.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selected)
                        return [2 /*return*/];
                    try {
                        JSON.parse(selected.config);
                    }
                    catch (_b) {
                        toast.error("Configuration must be valid JSON.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveConnector({
                            body: { connectors: [selected] },
                        }).unwrap()];
                case 2:
                    _a.sent();
                    toast.success("Connector saved!");
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.error(err_2);
                    toast.error("Failed to save connector.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "flex h-full gap-6 p-6 bg-[var(--colors-body-bg-sec)]" }, { children: [_jsxs("div", __assign({ className: "w-1/2 bg-[var(--colors-bg-default)] rounded-xl shadow-sm border border-[var(--colors-widget-border)] flex flex-col" }, { children: [_jsxs("div", __assign({ className: "flex items-center justify-between px-5 py-4 border-b" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx(FontAwesomeIcon, { icon: faPlug, className: "text-[var(--colors-label)]" }), _jsx("h2", __assign({ className: "text-base font-semibold text-[var(--colors-label)]" }, { children: "Connecteurs" }))] })), _jsxs("button", __assign({ onClick: addConnector, className: "inline-flex items-center gap-2 px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition" }, { children: [_jsx(FontAwesomeIcon, { icon: faPlus }), "Add connector"] }))] })), _jsxs("div", __assign({ className: "divide-y relative" }, { children: [isLoadConnector && _jsx(LoaderImage, {}), connectors.map(function (c) { return (_jsxs("div", __assign({ className: "flex items-center justify-between px-5 py-3 cursor-pointer transition ".concat((selected === null || selected === void 0 ? void 0 : selected.id) === c.id
                                    ? "bg-[var(--colors-body-bg)]"
                                    : "hover:bg-[var(--colors-body-bg-sec)]") }, { children: [_jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("div", __assign({ className: "font-medium text-sm text-[var(--colors-label)]" }, { children: c.name })), _jsxs("div", __assign({ className: "text-xs text-[var(--colors-label)] opacity-70" }, { children: [c.type, c.subType ? " (".concat(c.subType, ")") : "", " \u00B7 ", c.description] }))] })), _jsxs("div", __assign({ className: "flex items-center gap-3" }, { children: [_jsx("button", __assign({ onClick: function () { return setSelected(c); }, className: "text-[var(--colors-label)] hover:text-blue-600", title: "View details" }, { children: _jsx(FontAwesomeIcon, { icon: faEye }) })), _jsx("button", __assign({ onClick: function () { return handleDelete(c.id); }, className: "text-gray-400 hover:text-red-600", title: "Delete" }, { children: _jsx(FontAwesomeIcon, { icon: faTrash }) }))] }))] }), c.id)); })] }))] })), _jsx("div", __assign({ className: "w-1/2 bg-[var(--colors-bg-default)] rounded-xl shadow-sm border border-[var(--colors-widget-border)] p-5" }, { children: selected ? (_jsxs(_Fragment, { children: [_jsx("h2", __assign({ className: "text-base font-semibold text-[var(--colors-label)] mb-4" }, { children: "Connector details" })), _jsx("form", __assign({ onSubmit: function (e) {
                                e.preventDefault();
                                handleSave();
                            } }, { children: _jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4 text-sm" }, { children: [_jsxs("div", { children: [_jsx("label", __assign({ className: "text-xs text-[var(--colors-label)]" }, { children: "Name" })), _jsx(Input, { size: "sm", value: selected.name, onChange: function (e) { return updateSelected("name", e.target.value); } })] }), _jsxs("div", { children: [_jsx("label", __assign({ className: "text-xs text-[var(--colors-label)]" }, { children: "Type" })), _jsx(Select, __assign({ size: "sm", value: selected.type, onChange: function (e, value) {
                                                    if (!value)
                                                        return;
                                                    updateSelected("type", value);
                                                    if (value !== "LLM") {
                                                        updateSelected("subType", "");
                                                        updateSelected("config", JSON.stringify({ apiKey: "", model: "" }, null, 2));
                                                    }
                                                    else {
                                                        updateSelected("subType", "custom");
                                                        updateSelected("config", JSON.stringify({ apiKey: "", model: "" }, null, 2));
                                                    }
                                                } }, { children: mainTypes.map(function (t) { return (_jsx(Option, __assign({ value: t }, { children: t }), t)); }) }))] }), selected.type === "LLM" && (_jsxs("div", { children: [_jsx("label", __assign({ className: "text-xs text-[var(--colors-label)]" }, { children: "LLM Provider" })), _jsx(Select, __assign({ size: "sm", value: selected.subType, onChange: function (e, value) {
                                                    if (!value)
                                                        return;
                                                    updateSelected("subType", value);
                                                    if (value === "openai") {
                                                        updateSelected("config", JSON.stringify({ apiKey: "", model: "gpt-4o" }, null, 2));
                                                    }
                                                    else if (value === "anthropic") {
                                                        updateSelected("config", JSON.stringify({ apiKey: "", model: "claude-opus-4" }, null, 2));
                                                    }
                                                    else {
                                                        updateSelected("config", JSON.stringify({ apiKey: "", model: "" }, null, 2));
                                                    }
                                                } }, { children: llmSubTypes.map(function (t) { return (_jsx(Option, __assign({ value: t }, { children: t }), t)); }) }))] })), _jsxs("div", __assign({ className: "col-span-2" }, { children: [_jsx("label", __assign({ className: "text-xs text-[var(--colors-label)]" }, { children: "Description" })), _jsx(Input, { size: "sm", value: selected.description, onChange: function (e) {
                                                    return updateSelected("description", e.target.value);
                                                } })] })), _jsxs("div", __assign({ className: "col-span-2" }, { children: [_jsx("label", __assign({ className: "text-xs text-[var(--colors-label)]" }, { children: "Configuration (JSON)" })), _jsx("textarea", { value: selected.config, onChange: function (e) { return updateSelected("config", e.target.value); }, rows: 10, className: "w-full rounded-lg border border-gray-300 p-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-500" })] })), _jsx("div", __assign({ className: "mt-5" }, { children: _jsx("button", __assign({ type: "submit", className: "w-1/2 px-2 py-2 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition" }, { children: "Save" })) }))] })) }))] })) : (_jsx("div", __assign({ className: "h-full flex items-center justify-center text-[var(--colors-label)] text-sm" }, { children: "Select a connector to view its configuration" }))) }))] })));
}
